export default __webpack_public_path__ + "431e9bdc91e2e9e8613cb12e2e1b82b2.ttf";